<template>
    <b-card no-body class="my-2">
        <b-tabs v-model="tabIndex" card>
            <b-tab title="General" active>
                <b-card-body>
                    <b-form @submit.prevent="saveCustomer()">
                        <b-form-group
                            id="input-group-code"
                            label="Code:"
                            label-for="code"
                        >
                            <b-input
                                id="code"
                                name="code"
                                v-model="model.code"
                                type="text"
                            ></b-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                        >
                            <b-input
                                id="input-name"
                                v-model="model.name"
                                :error="errors.first('name')"
                                type="text"
                                required
                            ></b-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-1"
                            label="Email address:"
                            label-for="input-1"
                        >
                            <b-input
                                name="email"
                                v-model="model.email"
                                type="email"
                            ></b-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-1"
                            label="Telephone:"
                            label-for="phone"
                        >
                            <b-input
                                id="phone"
                                name="phone"
                                v-model="model.phone"
                                type="tel"
                            ></b-input>
                        </b-form-group>

                        <b-form-row
                            class="mt-6"
                            v-if="!isParentView && !hideButtons"
                        >
                            <b-col>
                                <b-button
                                    ref="submit"
                                    type="submit"
                                    v-show="false"
                                    >Submit</b-button
                                >

                                <portal
                                    to="customer-view-buttons"
                                    :disabled="tabIndex == 0"
                                >
                                    <b-button-group
                                        class="float-right"
                                        size="sm"
                                    >
                                        <b-button
                                            @click="
                                                $refs[
                                                    'locationSection'
                                                ].setSearchMode()
                                            "
                                            variant="secondary"
                                            :disabled="loading"
                                            v-if="
                                                hasPermissionUpdate &&
                                                tabIndex == 1
                                            "
                                            >Change Location</b-button
                                        >
                                        <b-button
                                            type="submit"
                                            v-if="hasPermissionUpdate"
                                            variant="primary"
                                            :disabled="loading ? true : false"
                                            >{{ submitLabel }}</b-button
                                        >

                                        <b-button
                                            @click="cancelCustomer()"
                                            variant="warning"
                                            v-show="tabIndex == 0"
                                        >
                                            Cancel
                                        </b-button>
                                        <b-button
                                            v-if="
                                                !isNew &&
                                                hasPermissionDelete &&
                                                tabIndex == 0
                                            "
                                            @click="deleteCustomer()"
                                            variant="danger"
                                        >
                                            Delete
                                        </b-button>
                                        <b-button
                                            variant="info"
                                            v-if="!isNew && tabIndex == 0"
                                            @click="$router.push(ordersRoute)"
                                        >
                                            View Orders
                                        </b-button>
                                    </b-button-group>
                                </portal>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card-body>
            </b-tab>
            <b-tab title="Location">
                <b-card-body>
                    <location-section
                        ref="locationSection"
                        v-model="model.location_section_id"
                        :hide-controls="true"
                        title="Location*"
                        @update-section-model="
                            evt => (locationSectionData = evt)
                        "
                    >
                    </location-section>
                    <portal-target name="customer-view-buttons"></portal-target>
                </b-card-body>
            </b-tab>
            <b-tab title="Users" v-if="!isNew">
                <b-card-body>
                    <customer-users :customer_id="id"></customer-users>
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
const _ = require('lodash')
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import LocationSection from '@/views/Location/LocationSection'
import CustomerUsers from './CustomerUsers.vue'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'customers-view',
    components: { CustomerUsers, LocationSection },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            tabIndex: 0,
            model: {
                id: 0,
                code: '',
                name: '',
                email: '',
                phone: '',
                location_section_id: null,
                location: null,
                section_name: null,
            },
            loading: false,
            locationSectionData: {},
            count: 0,
        }
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
        hideButtons: { type: Boolean, default: false },
    },
    computed: {
        isNew() {
            return !this.id
        },
        customer() {
            return this.$store.getters['customers/customer']
        },
        ordersRoute() {
            return `/admin/orders/?page=1&query=&customer_id=${this.model.id}&entity=1`
        },
        isParentView() {
            return this.$route.name != 'viewCustomer'
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Save'
            } else {
                return 'Create'
            }
        },
    },
    watch: {
        customer: function (model) {
            console.log('model before', model)
            let { locationSectionData } = this
            locationSectionData = locationSectionData || null
            this.model = {
                ...model,
                ...locationSectionData,
            }
            console.log('model after', this.model)
        },

        locationSectionData: {
            handler: _.debounce(function (val) {
                console.log('locationSectionData', val)
                this.syncModel(val)
            }, 500),
            deep: true,
        },

        'model.code': _.debounce(function (val) {
            this.$set(this.model, 'code', val)
            this.syncModel(this.locationSectionData, true)
        }, 500),
        'model.name': _.debounce(function (val) {
            this.$set(this.model, 'name', val)
            this.syncModel(this.locationSectionData, true)
        }, 500),
        'model.email': _.debounce(function (val) {
            this.$set(this.model, 'email', val)
            this.syncModel(this.locationSectionData, true)
        }, 500),
        'model.phone': _.debounce(function (val) {
            this.$set(this.model, 'phone', val)
            this.syncModel(this.locationSectionData, true)
        }, 500),
    },
    mounted() {
        const { id } = this
        if (id > 0) this.$store.dispatch('customers/fetchById', id)
    },
    methods: {
        syncModel(locationData, enforced) {
            const { model } = this
            const newModel = {
                ...model,
                ...locationData,
            }
            this.count++
            console.log('counting', this.count)
            if (enforced || !_.isEqual(newModel, model)) {
                console.log('newModel', newModel)
                this.model = newModel
                this.$emit('update-model', this.model)
            }
        },

        cancelCustomer() {
            this.$router.push({ name: 'customers' })
        },

        async saveCustomer() {
            const { model } = this
            try {
                console.log('saving')
                this.loading = true

                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Form Not Completed Properly!!')

                let { location_section_id, location } = { ...model }
                location = location || {}
                const { city, address1, address2 } = location

                if (!location_section_id && !city && (address1 || address2)) {
                    throw new Error(
                        'City is Required! Delete address if location not required!'
                    )
                }

                await this.$store.dispatch(
                    `customers/${model.id ? 'update' : 'create'}`,
                    model
                )
                if (this.isNew) {
                    this.doToast('Customer Created', 'Created', 'success')
                    this.$router.push({ name: 'customers' })
                } else {
                    this.doToast('Customer Updated', 'Updated', 'success')
                }
            } catch (error) {
                this.doToast(
                    'Error Detected',
                    error.message || error.response.data.error.message,
                    'warning'
                )
            } finally {
                console.log('customer data', model)
                this.loading = false
            }
        },

        async deleteCustomer() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/customers',
                deleteRoute: 'customers/delete',
            }
            const notificationFields = {
                type: 'Customer',
                errorMsg:
                    'Unable to delete Customer, an association exists with other records',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
}
</script>
<style></style>
